// Shared "weeks to complete" formula used by DeadlineSelector's recommended preview (account and
// team default-deadline drawers) and TeamAssignmentDeadlineMenu's per-team deadline summary.
export const computeDeadlineWeeksToComplete = (
  playlistDurationSeconds: number,
  trainingPaceHoursPerWeek: number
): number => Math.max(1, Math.ceil(playlistDurationSeconds / 3600 / trainingPaceHoursPerWeek));
